// @ts-nocheck
import { Routes, Route, Navigate } from 'react-router-dom'
import { ReactNode } from 'react'
import Profile from '../pages/Profile'
import MobileAuth from './pages/MobileAuth'
import PwaNotifications from './pages/PwaNotifications'
import MobileDashboard from './pages/MobileDashboard'
import MobileCases from './pages/MobileCases'
import MobileCaseDetail from './pages/MobileCaseDetail'
import MobileAdministrativeProcessDetail from './pages/MobileAdministrativeProcessDetail'
import MobileAgenda from './pages/MobileAgenda'
import MobileClients from './pages/MobileClients'
import MobileFinancial from './pages/MobileFinancial'
import MobileTasks from './pages/MobileTasks'
import NotificationHandler from '@/components/NotificationHandler'
import { AuthProvider } from '@/contexts/AuthContext'
import { NotificationProvider } from '@/contexts/NotificationContext'
import { MobileLayout } from './ui/MobileLayout'
import { RequireAuth } from './RequireAuth'
import { PwaAutoSubscribe } from './PwaAutoSubscribe'
import { PwaSwNavigationBridge } from './PwaSwNavigationBridge'

/**
 * Layout + guarda de autenticação aplicados em conjunto.
 * Rota /pwa/auth NÃO usa esse wrapper — por isso header/BottomNav não aparecem antes do login.
 */
const AuthedShell = ({ children }: { children: ReactNode }) => (
  <RequireAuth>
    <MobileLayout>{children}</MobileLayout>
  </RequireAuth>
)

export const PwaApp = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <NotificationHandler />
        {/* Faz o SW conseguir navegar dentro do SPA via postMessage */}
        <PwaSwNavigationBridge />
        {/* Auto-subscribe silencioso ao entrar no PWA logado */}
        <PwaAutoSubscribe />
        <Routes>
          {/* Raiz → dashboard (menu principal do app) */}
          <Route path="/" element={<Navigate to="/pwa/dashboard" replace />} />
          <Route path="/pwa" element={<Navigate to="/pwa/dashboard" replace />} />
          <Route path="/pwa.html" element={<Navigate to="/pwa/dashboard" replace />} />

          {/* Auth — sem MobileLayout (nada de header/BottomNav antes do login) */}
          <Route path="/auth" element={<MobileAuth />} />
          <Route path="/pwa/auth" element={<MobileAuth />} />

          {/* Menu principal — telas MOBILE-FIRST dedicadas */}
          <Route path="/pwa/dashboard"       element={<AuthedShell><MobileDashboard /></AuthedShell>} />
          <Route path="/pwa/cases"           element={<AuthedShell><MobileCases /></AuthedShell>} />
          <Route path="/pwa/processo/:id"    element={<AuthedShell><MobileCaseDetail /></AuthedShell>} />
          <Route path="/pwa/processo-administrativo/:id" element={<AuthedShell><MobileAdministrativeProcessDetail /></AuthedShell>} />
          <Route path="/pwa/agenda"          element={<AuthedShell><MobileAgenda /></AuthedShell>} />
          <Route path="/pwa/clients"         element={<AuthedShell><MobileClients /></AuthedShell>} />
          <Route path="/pwa/financial"       element={<AuthedShell><MobileFinancial /></AuthedShell>} />

          {/* Secundárias (acessíveis pelo menu lateral / deep-link de push) */}
          <Route path="/pwa/tasks"           element={<AuthedShell><MobileTasks /></AuthedShell>} />
          <Route path="/pwa/appointments"    element={<AuthedShell><MobileAgenda /></AuthedShell>} />
          <Route path="/pwa/profile"         element={<AuthedShell><Profile /></AuthedShell>} />
          <Route path="/pwa/notifications"   element={<AuthedShell><PwaNotifications /></AuthedShell>} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/pwa/dashboard" replace />} />
        </Routes>
      </NotificationProvider>
    </AuthProvider>
  )
}
